import { GoogleMap, InfoWindowF, useJsApiLoader } from "@react-google-maps/api";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const Location = () => {
    // const { isLoaded } = useLoadScript({
    //     googleMapsApiKey: import.meta.env.VITE_API_KEY_GOOGLE,
    // });
    const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: import.meta.env.VITE_API_KEY_GOOGLE,
  })
    const mapRef = React.useRef<google.maps.Map | null>(null);
    const center = React.useMemo(() => ({ lat:  -6.1329703, lng: 106.9270161}), []);
    React.useEffect(() => {
        if (isLoaded && mapRef.current) {
            const map = mapRef.current;

            // Create AdvancedMarkerElement
            const marker = new google.maps.marker.AdvancedMarkerElement({
                map,
                position: { lat: -6.1329703, lng: 106.9270161 },
                title: "Cafe Kopilibrasi",
            });

            // Optional: Add event listener to marker
            marker.addListener("click", () => {
                alert("Marker clicked!");
            });
        }
    }, [isLoaded]);
    return (
        <>
            <div className="w-full">
                <div className="flex flex-col lg:flex-row justify-center lg:px-32 px-5 pt-6 pb-4 bg-slate-700">
                    <div className="md:w-2/4 text-white mb-5 md:mb-0">
                        <p className="text-2xl">Lokasi Kami <br />disini ya... <br /></p>
                        <p className="mt-3 pr-3">Kavling Jl. Tipar Timur No.8 Blok B, RT.018/RW.4, West Semper, Cilincing, North Jakarta City, Jakarta 14130</p>
                        <Button>
                            <Link to={"https://maps.app.goo.gl/YwLjtvCBMTFxaZ4E7"} target="_blank">
                                Go Map
                            </Link>
                        </Button>
                    </div>
                    <div className="h-96 w-full">
                        {!isLoaded ? (
                            <h1>Loading...</h1>
                        ) : (
                            <GoogleMap
                                mapContainerClassName="map-container"
                                center={center}
                                zoom={17}
                                options={{
                                    disableDefaultUI: true, // Opsional: Nonaktifkan UI default untuk meningkatkan kinerja
                                }}
                            >
                                {/* <MarkerF 
                                position={{ lat: -6.1329703, lng: 106.9270161 }}  /> */}
                                <InfoWindowF position={{ lat: -6.1326, lng: 106.9270161 }}>
                                    <div className="flex flex-row justify-center gap-2 items-center">
                                        <img src="/src/assets/img/icon.png" style={{ height:"25px", width:"25px" }} alt="" />
                                        <h2 className="text-xl">Cafe Kopilibrasi</h2>
                                    </div>
                                </InfoWindowF>
                            </GoogleMap>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Location